/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { Component, ChangeDetectionStrategy } from "@angular/core";
import { OnInit } from "@angular/core";
import { Input } from "@angular/core";
import { RuiStore } from "@anvilor/ngx-rui";
import { IRuiControlComponent } from "@anvilor/ngx-rui";
import { AttentionBannerControl } from "./attention-banner-control";

@Component({
  selector: "attention-banner-button-control",
  template: `
    @if (!!control) {
    <app-attention-banner
      [label]="(control.label$ | async) ?? ''"
      [backgroundColor]="(control.color$ | async) ?? undefined"
      [height]="(control.height$ | async) ?? undefined"
      [closeable]="(control.closeable$ | async) ?? undefined"
    ></app-attention-banner>
    }
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AttentionBannerControlComponent implements IRuiControlComponent, OnInit {
  @Input() internalId!: string;
  control!: AttentionBannerControl;

  constructor(private store: RuiStore) {}

  ngOnInit() {
    this.control = new AttentionBannerControl(this.store, this.internalId);
  }
}
